import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { AccountService } from './account.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private router: Router,
    private accountService: AccountService,
  ) { }

  canActivate() {
    const path = this.accountService.getConfig().redirectPath || '';
    if (!this.accountService.isLoggedIn()) {
      this.router.navigate([path]);
      return false;
    }
    return true;
  }

}
